import slice from "../reducer/slice";

import { IState } from '../types/state';

export const updateAllStations = (stations: IState['allStations']['data']) => slice.actions.setAllStations(stations);
